/**
 * @generated SignedSource<<722456e2182d4f7f059b9a79080aba7f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Recipients_paymentAddresses$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_paymentAddresses">;
  readonly " $fragmentType": "Recipients_paymentAddresses";
};
export type Recipients_paymentAddresses$key = {
  readonly " $data"?: Recipients_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"Recipients_paymentAddresses">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Recipients_paymentAddresses",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSplit_paymentAddresses"
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};

(node as any).hash = "be916884162b8e2bf963170648579daf";

export default node;
